import { useTranslation } from "react-i18next";
import { CalendarRange } from "lucide-react";

// يوضح الفترة الفعلية المستخدمة في التقرير: الشهر أو المدى المخصص من الفلاتر أعلى الصفحة.
export const PeriodChip = ({ filters = {} }) => {
  const { t } = useTranslation();
  const start = filters.start || filters.from_date || "";
  const end = filters.end || filters.to_date || "";
  const custom = Boolean(start && end);
  return (
    <span className="flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1.5 text-xs font-bold text-primary"
          data-testid="report-period-chip">
      <CalendarRange className="h-3.5 w-3.5" />
      {custom ? `${start} → ${end}` : filters.month}
      <span className="font-semibold text-muted-foreground">
        · {t(custom ? "reportPeriod.custom" : "reportPeriod.month")}
      </span>
    </span>
  );
};
